import { FtlRoutingViewModel } from "../../ViewModel/FtlRoutingViewModel";
import { getListOfOdcsFromRoutingTable } from "../RightSide/FtlTab/GetListOfOdcsFromRoutingTable";
import { OdcLoadTypeViewModel } from "../../ViewModel/OdcLoadTypeViewModel";

export const getOdcs = (routingTable: FtlRoutingViewModel[] | undefined) => {
  const listOfNamedOdcs = getListOfOdcsFromRoutingTable(routingTable);
  const odcs: Array<OdcLoadTypeViewModel> = [];

  listOfNamedOdcs.forEach((names) => {
    odcs.push({
      OdcGsdb: names,
    });
  });

  return odcs;
};
